import Popover from '@material-ui/core/Popover';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  .MuiButton-root {
    width: 85.43px;
    height: 24px;
    padding: 4px;
    background-color: #3c71dd;
    border-radius: 3px;
    transition: opacity 300ms;

    &:disabled {
      background-color: #aeaeae;
    }

    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      text-transform: capitalize;
    }
    
    &:hover {
      background-color: #3c71dd;
      opacity: 0.7;
    }
  }

  .config-label-actions {
    width: 72px;
    height: 22px;
    padding: 0px 3px;
    display: none;

    &.active {
      display: flex;
      @media (max-width: 768px) {
        display: none;
      }
    }

    .config-label-action {
      background: none;
      border: none;
      text-decoration: none;
      color: #797e82;
      padding: 3px 36px 3px 0px;
      /* padding-right: 14px; */

      .select {
        position: relative;
        width: 100%;
        height: 20px;
        padding: 0px;
        color: #5e5e5e;
      }

      .a-icon {
        margin-top: 3.5px;

        &.disabled {
          path {
            fill: #b6b6b6;
          }
        }
      }

      &:hover {
        color: #3c71dd;
      }

      .disabled {
        color: #b6b6b6;
      }

      .MuiSvgIcon-fontSizeSmall {
        font-size: 1rem;
      }
    }

    .config-label-align-action {
      background: none;
      border: none;
      text-decoration: none;
      color: #797e82;
      padding: 3px 7px 0px 7px;
    }

    .save {
      padding-left: 40px;
    }
  }
`;

/**
 * Estilização do componente StyledPopupConfigureLabel
 */
 export const StyledPopupConfigureLabel = styled(Popover)`
 z-index: 1600 !important;

 .MuiPopover-paper {
   height: 66px;
   border-radius: 3px;
   padding: 21px 36px;
   min-width: 250px;
   overflow-x: initial;
   overflow-y: initial;
   background: #f5f5f5;

   .arrow-configure-label {
     position: absolute;
     border-left: 11px solid transparent;
     border-right: 11px solid transparent;
     border-bottom: 12px solid #fff;
     left: 12px;
     top: -12px;
     opacity: 1;
     transition: opacity 250ms;
   }
 }
`;
